import React from "react";

function RoleCard({ icon, title, description, onClick, available = true }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={!available}
      className={`group relative flex flex-1 flex-col items-center gap-3 rounded-2xl border-2 p-6 text-center transition ${
        available
          ? "border-gray-100 bg-white hover:border-sky hover:shadow-card"
          : "cursor-not-allowed border-gray-100 bg-gray-50 opacity-60"
      }`}
    >
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-sky/10 text-2xl text-sky-dark transition group-hover:bg-sky group-hover:text-white">
        {icon}
      </div>
      <h3 className="text-base font-bold text-navy">{title}</h3>
      <p className="text-sm text-gray-500">{description}</p>
      {!available && (
        <span className="absolute left-3 top-3 rounded-full bg-gray-200 px-2 py-0.5 text-[10px] font-bold text-gray-500">
          به‌زودی
        </span>
      )}
    </button>
  );
}

export default function RoleSelect({ onSelect, onBack }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-surface px-4 py-10">
      <div className="w-full max-w-2xl">
        {onBack && (
          <button
            onClick={onBack}
            className="mb-4 flex items-center gap-1 text-xs font-bold text-gray-400 transition hover:text-navy"
          >
            <span>→</span>
            بازگشت به پنل
          </button>
        )}
        <div className="mb-8 text-center">
          <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-2xl bg-navy text-2xl text-white">
            🚗
          </div>
          <h1 className="text-2xl font-extrabold text-navy">قولنامه هوشمند</h1>
          <p className="mt-2 text-sm text-gray-500">
            قرارداد ۲۴ — تنظیم آنلاین و گام‌به‌گام قولنامه خرید و فروش خودرو
          </p>
        </div>

        <div className="rounded-2xl bg-white p-6 shadow-card">
          <h2 className="mb-4 text-center text-sm font-bold text-navy-light">
            نقش خود را در این معامله انتخاب کنید
          </h2>

          {/* ردیف اول: فروشنده اول یا خریدار اول */}
          <p className="mb-3 text-xs font-semibold text-gray-400 text-center">
            چه کسی اول اقدام می‌کند؟
          </p>
          <div className="flex flex-col gap-4 sm:flex-row">
            <RoleCard
              icon="🚗"
              title="فروشنده"
              description="ثبت اطلاعات خودرو، شرایط معامله و ارسال لینک به خریدار"
              onClick={() => onSelect("seller")}
            />
            <RoleCard
              icon="🧾"
              title="خریدار"
              description="ثبت اطلاعات هویتی خریدار و ارسال لینک به فروشنده برای تکمیل"
              onClick={() => onSelect("buyerFirst")}
            />
            <RoleCard
              icon="🧩"
              title="ثبت یک‌نفره"
              description="همه اطلاعات را یک نفر وارد می‌کند و امضای اختیاری است"
              onClick={() => onSelect("singlePerson")}
            />
          </div>

          {/* ردیف دوم: انواع دیگر قرارداد */}
          <div className="my-6 border-t border-gray-100" />
          <p className="mb-3 text-center text-xs font-semibold text-gray-400">
            یا یک نوع دیگر از قرارداد را ثبت کنید
          </p>
          <div className="flex flex-col gap-4 sm:flex-row">
            <RoleCard
              icon="🔍"
              title="بازرسی کارشناسی خودرو"
              description="ثبت برگه بازرسی فنی خودرو توسط کارشناس، به‌صورت یک‌نفره"
              onClick={() => onSelect("vehicleInspection")}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
